export const base = 'contact-search';

export const contactSearch = `${base}/get-contact`;
